/* global document, window */
(function () {
  var TARGET_SELECTORS = [
    '.swym-bis-trigger',
    '.swym-button',
    '.klaviyo-bis-trigger',
    '[data-bis-open]',
    '[data-restock-open]',
    '[data-back-in-stock-button]',
  ];

  function getVariantId(btn) {
    var datasetId =
      btn.getAttribute('data-variant-id') || btn.getAttribute('data-variant');
    if (datasetId) {
      datasetId = String(datasetId).trim();
      if (datasetId) return datasetId;
    }

    var form = btn.closest('form');
    if (!form) return null;

    var idInput = form.querySelector('[name="id"]');
    if (!idInput) return null;

    var value = '';
    if (idInput.tagName === 'SELECT') {
      value = idInput.value || idInput.getAttribute('value') || '';
    } else {
      value = idInput.value || idInput.getAttribute('value') || '';
    }

    value = String(value).trim();
    return value || null;
  }

  function matchesVariant(target, variantId) {
    if (!variantId) return true;

    var attrs = [
      'data-variant-id',
      'data-variant',
      'data-variantid',
      'data-variantids',
      'data-variant_ids',
      'data-variants',
      'data-variant-ids',
    ];
    var hasAttr = false;
    for (var i = 0; i < attrs.length; i++) {
      if (!target.getAttribute) continue;
      var raw = target.getAttribute(attrs[i]);
      if (!raw) continue;
      hasAttr = true;
      var values = String(raw).split(/[,\s]+/);
      for (var j = 0; j < values.length; j++) {
        var value = values[j];
        if (!value) continue;
        value = value.trim().replace(/^['"\[]+|['"\]]+$/g, '');
        if (!value) continue;
        if (value === variantId || value == variantId) {
          return true;
        }

        var parts = value.split('/');
        if (parts.length > 1) {
          var tail = parts[parts.length - 1];
          if (tail === variantId || tail == variantId) {
            return true;
          }
        }
      }
    }

    return !hasAttr;
  }

  function collectCandidates(root, selector, btn, bucket) {
    if (!root) return;
    if (root.matches && root !== btn && root.matches(selector)) {
      bucket.push(root);
    }

    var nodeList = root.querySelectorAll ? root.querySelectorAll(selector) : [];
    for (var i = 0; i < nodeList.length; i++) {
      if (nodeList[i] !== btn) {
        bucket.push(nodeList[i]);
      }
    }
  }

  function findTarget(btn) {
    var variantId = getVariantId(btn);
    var seen = [];

    var containers = [];
    var scopes = [
      '[data-product-id]',
      '[data-product_handle]',
      '[data-product-handle]',
      '[data-product]',
      '[data-productid]',
      '[data-product-url]',
      '.product-block',
      '.product',
      '.product-form',
    ];
    for (var i = 0; i < scopes.length; i++) {
      var candidate = btn.closest(scopes[i]);
      if (candidate && containers.indexOf(candidate) === -1) {
        containers.push(candidate);
      }
    }

    var node = btn;
    while (node) {
      if (containers.indexOf(node) === -1) {
        containers.push(node);
      }
      node = node.parentElement;
    }

    if (containers.indexOf(document) === -1) {
      containers.push(document);
    }

    for (var c = 0; c < containers.length; c++) {
      var root = containers[c];
      for (var s = 0; s < TARGET_SELECTORS.length; s++) {
        var selector = TARGET_SELECTORS[s];
        var bucket = [];
        collectCandidates(root, selector, btn, bucket);
        for (var k = 0; k < bucket.length; k++) {
          var target = bucket[k];
          if (seen.indexOf(target) !== -1) continue;
          seen.push(target);
          if (target.classList && target.classList.contains('gBackInStockBtn'))
            continue;
          if (!matchesVariant(target, variantId)) continue;
          return target;
        }
      }
    }

    return null;
  }

  function getProductUrl(btn) {
    if (!btn) return null;

    var attrs = ['data-product-url', 'href'];
    for (var i = 0; i < attrs.length; i++) {
      var attr = attrs[i];
      var value = btn.getAttribute && btn.getAttribute(attr);
      if (value) return value;
    }

    var containers = [];
    var node = btn;
    while (node) {
      containers.push(node);
      if (node.getAttribute) {
        var containerUrl = node.getAttribute('data-product-url');
        if (containerUrl) return containerUrl;
      }
      node = node.parentElement;
    }

    for (var c = 0; c < containers.length; c++) {
      var scope = containers[c];
      if (!scope.querySelector) continue;
      var link = scope.querySelector(
        'a[data-product-url], a.product-block__title-link, .product-block__image[href]'
      );
      if (link) {
        var href =
          link.getAttribute('data-product-url') || link.getAttribute('href');
        if (href) return href;
      }
    }

    return null;
  }

  document.addEventListener(
    'click',
    function (e) {
      var btn =
        e.target &&
        e.target.closest &&
        e.target.closest('.gBackInStockBtn, [data-back-in-stock-button]');
      if (!btn) return;

      var productUrl = getProductUrl(btn);
      var target = findTarget(btn);
      if (target) {
        if (typeof e.preventDefault === 'function') e.preventDefault();
        if (typeof target.click === 'function') {
          target.click();
        } else {
          try {
            target.dispatchEvent(
              new MouseEvent('click', {
                bubbles: true,
                cancelable: true,
                view: window,
              })
            );
          } catch (err) {
            var fallbackEvent = document.createEvent('MouseEvents');
            fallbackEvent.initEvent('click', true, true);
            target.dispatchEvent(fallbackEvent);
          }
        }
        return;
      }

      if (typeof e.preventDefault === 'function') e.preventDefault();

      document.dispatchEvent(
        new CustomEvent('pnm:bis:open', {
          bubbles: true,
          detail: { trigger: btn, productUrl: productUrl },
        })
      );
    },
    true
  );
})();
